import React from 'react';
import { Select, Box, Button, RadioGroup } from '@amzn/awsui-components-console';

export default function FilterSet(props) {
    const setSelectedOption = (option, name) => {
        props.onFilterChange({
            ...props.filters,
            [name]: {
                ...props.filters[name],
                selectedOption: option,
            },
        });
    };

    const selectList = Object.keys(props.filters).map((name) => {
        const filter = props.filters[name];

        return (
            <Box margin={{ vertical: 's' }} key={name}>
                <Select
                    selectedOption={filter.selectedOption}
                    onChange={({ detail }) => setSelectedOption(detail.selectedOption, name)}
                    options={filter.options}
                    selectedAriaLabel="Selected"
                />
            </Box>
        );
    });

    return (
        <div>
            <RadioGroup
                onChange={({ detail }) => {
                    props.onThingTypeChange(detail);
                }}
                value={props.thingType}
                items={[
                    { value: 'DFEdges', label: 'Hosts' },
                    { value: 'DFDevices', label: 'Devices' },
                ]}
            />
            {selectList}
            <Button onClick={(detail) => props.onClearFilterClick()}>Clear filters</Button>
        </div>
    );
}
